import React, { type ReactNode } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useChatDashboardAccess } from '../features/chat/useChatDashboardAccess';

interface ChatAccessGuardProps {
    children: ReactNode;
}

export const ChatAccessGuard: React.FC<ChatAccessGuardProps> = ({ children }) => {
    const access = useChatDashboardAccess();

    if (access === 'checking') {
        return (
            <Box role="status" aria-live="polite" sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress size={28} aria-label="Checking chat access" />
            </Box>
        );
    }

    if (access === 'denied') {
        return (
            <Box sx={{ p: { xs: 2, md: 3 } }}>
                <Alert severity="error">Access denied. Session-view or session-management permissions are required.</Alert>
            </Box>
        );
    }

    return <>{children}</>;
};
